module.exports = __webpack_public_path__ + "img/frame (261).9730dd7f.jpg";